var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DC2626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35005 11.426L9.17405 6.3H10.8241L10.6591 11.426H9.35005ZM10.0101 14.055C9.72405 14.055 9.49305 13.9707 9.31705 13.802C9.14105 13.626 9.05305 13.417 9.05305 13.175C9.05305 12.9257 9.14105 12.7167 9.31705 12.548C9.49305 12.3793 9.72405 12.295 10.0101 12.295C10.2887 12.295 10.5124 12.3793 10.6811 12.548C10.8571 12.7167 10.9451 12.9257 10.9451 13.175C10.9451 13.417 10.8571 13.626 10.6811 13.802C10.5124 13.9707 10.2887 14.055 10.0101 14.055Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlocked);
export default __webpack_public_path__ + "static/media/warning-blocked.0977bcc2c23a4bbafd99eddab528a6f1.svg";
export { ForwardRef as ReactComponent };